import { dateFormat } from '../utils/date';
import ListTable, { TableLinkBtn } from '../components/shared/ListTable';
import { ROLES } from '../utils/appRoles';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import TableUpdateActionButton from '../components/shared/buttons/TableUpdateActionbutton';
import { unAuthAxios } from '../utils/axios';
import MailLockOutlinedIcon from '@mui/icons-material/MailLockOutlined';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import { usePage } from "../contexts/PageProvider";
import { USER_LIST_URL } from '../contexts/PageProvider';
import {useNotifications} from 'reapop';


const getRoleLabel = (role) => {
    const filterResult = ROLES.find(item => item.value === role);
    return filterResult?.label || role;
} 

const getStatusText = (last_login) => {
    return last_login ? 'Actif' : 'Inactif';
} 

const COLUMNS = [
    { 
        id: 'first_name', 
        label: 'Prénom', 
    },
    { 
        id: 'last_name', 
        label: 'Nom', 
    },
    {
        id: 'email',
        label: 'Email',
    },
    {
        id: 'phone_number',
        label: 'Téléphone',
    },
    {
        id: 'type',
        label: 'Rôle',
        format: getRoleLabel,
    },
    {
        id: 'title',
        label: 'Poste',
    },
    {
        id: 'created_at',
        label: 'Créer le',
        format: dateFormat,
    },
    {
        id: 'updated_at',
        label: 'Modifier le',
        format: dateFormat,
    },
    {
        id: 'last_login',
        label: 'Statut',
        format: getStatusText
    },
    {
        id: 'action_block',
        label: 'Actions',
    },
];

const ActionBlock = ({props}) => {
    const navigate = useNavigate();
    const {notify} = useNotifications();

    const showUserUpdatePage = (idx) => {
        const path = ["update", idx].join('/');
        navigate(path);
    }

    const forgottenLinkProcess = async(email, password_forgotten) => {
        try {
            await unAuthAxios.patch('user/reset_password/', {email, password_forgotten})
            notify('Un mail de réinitialisation de mot de passe a été envoyé à l\'utilisateur', 'info', {dismissAfter: 5000}); 
        } catch (error) {
            // console.error(error)
        }    
    }

    const activationLinkProcess = async(email, password_forgotten) => {
        try {
            await unAuthAxios.patch('user/reset_password/', {email, password_forgotten});
            notify('Un mail d\'activation de compte a été envoyé à l\'utilisateur', 'info', {dismissAfter: 5000}); 
        } catch (error) {
            // console.error(error)
        }    
    }

    const createForgottenLink = async(user) => {
        if (user?.is_active && user?.last_login) {
            var email = user.email;
            var password_forgotten = true;
            email = email.replace(/_/g,"_<wbr>"); 
            const message = `Un mail va être envoyé à ${email} pour qu'il change son mot de passe. Voulez-vous continuer ?`
            notify(message, 
                'info', 
                {allowHTML: true,
                buttons: [{name: "Oui", primary: true, onClick: async() => {await  forgottenLinkProcess(email, password_forgotten)}}, {name: "Non", primary: false, onClick: () => {}}]});
        } else {
            alert("Ce compte est inactif. Vous ne pouvez pas demander la réinitialisation du mot de passe.");
        } 
        
    }    
    
    const createActivationLink = async(user) => {
        if (user?.is_active && user?.last_login == null) {
            var email = user.email;
            var password_forgotten = false;
            email = email.replace(/_/g,"_<wbr>"); 
            const message = `Un mail va être envoyé à ${email} pour qu'il puisse activer son compte. Voulez-vous continuer ?`
            notify(message, 
                'info', 
                {allowHTML: true,
                buttons: [{name: "Oui", primary: true, onClick: async() => {await  activationLinkProcess(email, password_forgotten)}}, {name: "Non", primary: false, onClick: () => {}}]});
        } else {
            alert("Ce compte est déjà actif.");
        }        
    }

    return (
        <span>
            {/* <PasswordForgotten */}
            {props.last_login ? <TableUpdateActionButton clickHandler={createForgottenLink} idx={props}><MailLockOutlinedIcon/></TableUpdateActionButton>
            : <TableUpdateActionButton clickHandler={createActivationLink} idx={props}><ForwardToInboxOutlinedIcon/></TableUpdateActionButton>}            
            <TableUpdateActionButton clickHandler={showUserUpdatePage} idx={props?.id}/>
        </span>
    )

}

const UserListPage = () => {
    const { pageData, setPageData } = usePage();
    if (pageData.url != USER_LIST_URL) {
        setPageData({url: USER_LIST_URL, title: "Utilisateur"});      
    }
    usePage({title: "Utilisateur"});
    
    const extraColumnSetValue = (props) => {
        const action_block = <ActionBlock props={props} key={props.id}/>;
        return {action_block, ...props};
    }

    return (
        <Box>
            <TableLinkBtn to={'/users/create'}><PersonAddOutlinedIcon/></TableLinkBtn>
            <ListTable
                columns={COLUMNS}
                list_url="user/"
                callback={extraColumnSetValue}
            />
        </Box>
    );
};

export default UserListPage;
